import React, { PropTypes } from 'react';
import { defaultThumbnail } from 'utils/assets';
import AsyncImage from 'common/components/AsyncImage';

const getImageUrl = node => {
  if (node.image) {
    return node.image.xhdpi;
  }

  return defaultThumbnail();
};

const NodeImage = ({ node }) => (
  <AsyncImage src={getImageUrl(node)} className="ui tiny rounded image" />
);

NodeImage.propTypes = {
  node: PropTypes.object.isRequired,
};

export default NodeImage;



// WEBPACK FOOTER //
// ./src/modules/catalog/components/NodeImage.js